import axios from "axios";

const uri = "https://www.lefisc.com.br/api/apiDIFAL/calcular/difal/nc";
const uriteste = "http://localhost:55882/calcular/difal/nc";
const tok = "bd329d7b833e98162cffa558f9389759";

export default {
  calcularNC(objeto) {
    console.log(objeto)
    return axios.post(`${uri}/${tok}`, objeto).then(
      res => {
        console.log("enviado com sucesso!");
        return res;
      },
      err => {
        throw new Error(console.error(err));
      }
    );
  }
};



// WEBPACK FOOTER //
// ./src/services/serviceCalculoNC.js